var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useRef, } from 'react';
import { proAllowanceApi } from '../api/pro-allowance';
import { ERR_GENERIC } from '../constants/response-error-messages';
import { track, trackOnce } from '../utils/analytics';
import { PRO_GET_PAGE_LOAD_ERROR, PRO_GET_POST_PAGE_ERROR, PRO_ALLOWANCE_OVERLAY, } from '../constants/analytics';
var trackPageLoadErrorOnce = trackOnce();
var ProAllowanceContext = React.createContext(null);
var ProAllowanceProvider = function (_a) {
    var children = _a.children;
    var isMountedRef = useRef(false);
    var _b = __read(useState(false), 2), loading = _b[0], setLoading = _b[1];
    var _c = __read(useState(false), 2), initialCallsComplete = _c[0], setInitialCallsComplete = _c[1];
    var _d = __read(useState(null), 2), allowances = _d[0], setAllowances = _d[1];
    var _e = __read(useState(null), 2), alertMessage = _e[0], setAlertMessage = _e[1];
    var _f = __read(useState(null), 2), allPAACards = _f[0], setAllPAACards = _f[1];
    var _g = __read(useState(null), 2), allPmtCards = _g[0], setAllPmtCards = _g[1];
    var _h = __read(useState(null), 2), allProAllowanceUsers = _h[0], setAllProAllowanceUsers = _h[1];
    useEffect(function () {
        isMountedRef.current = true;
        return function () {
            isMountedRef.current = false;
        };
    }, []);
    var triggerGetAllowances = function () {
        setLoading(true);
        return proAllowanceApi
            .getAllowances()
            .then(function (_a) {
            var data = _a.data;
            if (!isMountedRef.current)
                return;
            setAllowances(data);
        })
            .catch(function (error) {
            var message = ERR_GENERIC.message;
            var code = error.code;
            if (!initialCallsComplete) {
                trackPageLoadErrorOnce(PRO_GET_PAGE_LOAD_ERROR, {
                    displayType: 'page',
                    message: message,
                    code: code,
                });
            }
            else {
                track(PRO_GET_POST_PAGE_ERROR, {
                    displayType: 'inline',
                    message: message,
                    code: code,
                    type: 'error',
                    pageSection: PRO_ALLOWANCE_OVERLAY,
                });
            }
        })
            .finally(function () {
            if (!isMountedRef.current)
                return;
            setLoading(false);
        });
    };
    var triggerGetAllProAllowanceUsers = function () {
        setLoading(true);
        return proAllowanceApi
            .getAllProAllowanceUsers()
            .then(function (_a) {
            var data = _a.data;
            if (!isMountedRef.current)
                return;
            setAllProAllowanceUsers(data);
        })
            .catch(function (error) {
            // TODO: handle error
            var message = ERR_GENERIC.message;
            var code = error.code;
            if (!initialCallsComplete) {
                trackPageLoadErrorOnce(PRO_GET_PAGE_LOAD_ERROR, {
                    displayType: 'page',
                    message: message,
                    code: code,
                });
            }
            else {
                track(PRO_GET_POST_PAGE_ERROR, {
                    displayType: 'inline',
                    message: message,
                    code: code,
                    type: 'error',
                    pageSection: PRO_ALLOWANCE_OVERLAY,
                });
            }
        })
            .finally(function () {
            if (!isMountedRef.current)
                return;
            setLoading(false);
        });
    };
    var checkInactiveButtonStatus = function () {
        var _a;
        var hasExistingUsers = !!((_a = allProAllowanceUsers === null || allProAllowanceUsers === void 0 ? void 0 : allProAllowanceUsers.users) === null || _a === void 0 ? void 0 : _a.length);
        var hasExistingPAACards = !!(allPAACards === null || allPAACards === void 0 ? void 0 : allPAACards.length);
        var hasExistingPmtCards = !!(allPmtCards === null || allPmtCards === void 0 ? void 0 : allPmtCards.length);
        return !hasExistingUsers || !hasExistingPmtCards || !hasExistingPAACards;
    };
    useEffect(function () {
        Promise.allSettled([
            triggerGetAllProAllowanceUsers(),
            triggerGetAllowances(),
            getAllPAACards(),
            getAllPmtCards(),
        ]).then(function () {
            if (!isMountedRef.current)
                return;
            setInitialCallsComplete(true);
        });
    }, []);
    var getAllPAACards = function () {
        setLoading(true);
        return proAllowanceApi
            .getAllPAACards()
            .then(function (_a) {
            var data = _a.data;
            if (!isMountedRef.current)
                return;
            setAllPAACards(data.paymentCards.paymentCard);
        })
            .catch(function (error) {
            // TODO: handle error
            var message = ERR_GENERIC.message;
            var code = error.code;
            if (!initialCallsComplete) {
                trackPageLoadErrorOnce(PRO_GET_PAGE_LOAD_ERROR, {
                    displayType: 'page',
                    message: message,
                    code: code,
                });
            }
            else {
                track(PRO_GET_POST_PAGE_ERROR, {
                    displayType: 'inline',
                    message: message,
                    code: code,
                    type: 'error',
                    pageSection: PRO_ALLOWANCE_OVERLAY,
                });
            }
        })
            .finally(function () {
            if (!isMountedRef.current)
                return;
            setLoading(false);
        });
    };
    var getAllPmtCards = function () {
        setLoading(true);
        return proAllowanceApi
            .getAllPmtCards()
            .then(function (_a) {
            var data = _a.data;
            if (!isMountedRef.current)
                return;
            setAllPmtCards(data.paymentCards.paymentCard);
        })
            .catch(function (error) {
            // TODO: handle error
            var message = ERR_GENERIC.message;
            var code = error.code;
            if (!initialCallsComplete) {
                trackPageLoadErrorOnce(PRO_GET_PAGE_LOAD_ERROR, {
                    displayType: 'page',
                    message: message,
                    code: code,
                });
            }
            else {
                track(PRO_GET_POST_PAGE_ERROR, {
                    displayType: 'inline',
                    message: message,
                    code: code,
                    type: 'error',
                    pageSection: PRO_ALLOWANCE_OVERLAY,
                });
            }
        })
            .finally(function () {
            if (!isMountedRef.current)
                return;
            setLoading(false);
        });
    };
    return (React.createElement(ProAllowanceContext.Provider, { value: {
            loading: loading,
            setLoading: setLoading,
            initialCallsComplete: initialCallsComplete,
            allowances: allowances,
            setAllowances: setAllowances,
            triggerGetAllowances: triggerGetAllowances,
            triggerGetAllProAllowanceUsers: triggerGetAllProAllowanceUsers,
            alertMessage: alertMessage,
            setAlertMessage: setAlertMessage,
            allPAACards: allPAACards,
            getAllPAACards: getAllPAACards,
            allProAllowanceUsers: allProAllowanceUsers,
            allPmtCards: allPmtCards,
            checkInactiveButtonStatus: checkInactiveButtonStatus,
        } }, children));
};
export { ProAllowanceProvider, ProAllowanceContext };
